import { Box } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};


export default function ClientSlide({client}){
    return(
        <>
            <Carousel
                responsive={responsive}
                infinite={true}
                draggable={false}
                swipeable={true}
                showDots={false}
                centerMode={true}
                autoPlay={true}
                autoPlaySpeed={1500}
                arrows={false}
                NavButtonsAlwaysInvisible={true}
                indicators={false}
                keyBoardControl={true}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                containerClass="carousel-container"
            >
                {
                    client.map((item) => {
                        return (
                            <Box
                                key={item.id}
                                sx={{ display: "flex", alignItems: "center", height: 200 , justifyContent:"center"}}
                                >
                                <img
                                src={item.img}
                                style={{
                                    width: 200,
                                    height: 100,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                                alt=""
                                />
                            </Box>
                        
                        )
                    })
                }
            </Carousel>
            {/* <Slider {...settings}>
            {client?.map((item) => (
              <Box
                key={item.id}
                sx={{ display: "flex", alignItems: "center", height: 200 , justifyContent:"center"}}
              >
                <img
                  src={item.img}
                  style={{
                    width: 200,
                    height: 100,
                    display: "flex",
                    alignItems: "center",
                  }}
                  alt=""
                />
              </Box>
            ))}
          </Slider> */}
        </>
    )
}